import Controller from '../components/Controller';
import GeoLiveHighlight from './GeoLiveHighlight';
import FeedbackController from '../feedback/FeedbackController';
import Util from '../common/Util';
// import EventController from '../common/EventController';

/**
 * 高亮模块控制器,负责管理所有被高亮的对象。
 * 统一管理要素的高亮和取消高亮，清除高亮等操作.
 */
export default class HighlightController extends Controller {
    /**
     * 初始化构造函数,设置高亮模块引用的反馈操作对象，高亮要素容器.
     * @return {undefined}
     */
    constructor() {
        super();
        // this.eventController = EventController.getInstance();
        this.highlightItems = {};
        this.highlightRules = {};
    }

    loadConfig(config) {
        if (!config) {
            return;
        }

        Util.forOwn(config, (value, key) => {
            if (Util.has(this.highlightRules, key)) {
                throw new Error(`高亮规则存在重复:${key}`);
            }
            this.highlightRules[key] = value;
        });
    }

    getRule(key, ruleVal) {
        if (ruleVal) {
            return ruleVal;
        }

        if (!Util.has(this.highlightRules, key)) {
            return null;
        }

        return this.highlightRules[key];
    }

    /**
     * 高亮指定的要素，接收通过getByPid返回的要素数据模型.
     * @param {Object} geoLiveObject - 要素数据模型.
     * @return {null | string}.
     */
    highlight(geoLiveObject, ruleVal) {
        if (!geoLiveObject) {
            return null;
        }

        const type = geoLiveObject.geoLiveType;
        const rule = this.getRule(type, ruleVal);
        if (!rule) {
            return null;
        }

        const key = Util.uuid();

        const highlight = new GeoLiveHighlight(this.map, geoLiveObject, rule);
        highlight.highlight();
        this.highlightItems[key] = highlight;
        this.map.FeedbackController.add(highlight.feedback);
        this.map.FeedbackController.refresh();
        return key;
    }

    /**
     * 清除指定的要素的高亮效果
     * @param {string} key - 参数为highlight方法的返回的key
     * @return {undefined}.
     */
    unHighlight(key) {
        if (!key) {
            return;
        }

        const highlight = this.highlightItems[key];
        if (!highlight) {
            return;
        }

        this.map.FeedbackController.del(highlight.feedback);
        this.map.FeedbackController.refresh();
        delete this.highlightItems[key];
    }

    /**
     * 清除指定的要素集的高亮效果
     * @param {string} keys - 参数为highlight方法的返回的key
     * @return {undefined}.
     */
    unHighlights(keys = []) {
        if (!keys || keys.length == 0) {
            return;
        }

        keys.forEach(key => {
            const highlight = this.highlightItems[key];
            if (!highlight) {
                return;
            }

            this.map.FeedbackController.del(highlight.feedback);
            delete this.highlightItems[key];
        });

        this.map.FeedbackController.refresh();
    }

    /**
     * 清除所有的高亮要素.
     * @return {undefined}.
     */
    clearHighlight() {
        const keys = Object.getOwnPropertyNames(this.highlightItems);
        keys.forEach(key => {
            const highlight = this.highlightItems[key];
            this.map.FeedbackController.del(highlight.feedback);
            delete this.highlightItems[key];
        });

        this.map.FeedbackController.refresh();
    }

    /**
     * 判断是否存在高亮要素
     * @returns {boolean}.
     */
    isEmpty() {
        const keys = Object.getOwnPropertyNames(this.highlightItems);
        return keys.length === 0;
    }

    /**
     * 刷新高亮效果.
     * @return {undefined}
     */
    refresh() {
        const keys = Object.getOwnPropertyNames(this.highlightItems);
        keys.forEach(key => {
            const highlight = this.highlightItems[key];
            highlight.highlight();
        });

        this.map.FeedbackController.refresh();
    }

    /**
     * 销毁单例对象.
     * @returns {undefined}
     */
    destroy() {
        this.highlightRules = {};
        this.map.getLeafletMap().off('TileLayersLoaded');
        HighlightController.instance = null;
    }
}
